import React from 'react';
import 'react-modal-video/scss/modal-video.scss';
import ContactForm from "../../components/ContactForm";
function Block9() {
    return (
            <section className="contact-section layout-pb-50 layout-pt-50" style={{background: "#E7ECFF"}}>
                <div className="auto-container">
                    <div className="sec-title-outer">
                        <div className="sec-title" style={{width: "100%", textAlign: "center"}}>
                            <h2 className="homepage">Contactez-nous <span>pour découvrir la hotline</span>
                            </h2>
                            <div className="text homepage">
                                Intéressé.e par la hotline Talents Handicap ? Remplissez ce formulaire et notre équipe vous recontactera rapidement pour vous présenter cette solution clé en main.
                            </div>
                        </div>
                    </div>
                    <div className="contact-form default-form">
                        <ContactForm/>
                    </div>
                </div>
            </section>
    )
}

export default Block9;
